import React, { useEffect } from 'react';

/**
 * Componente che serve come proxy per il feed XML generato da Netlify Functions.
 * Quando viene acceduto, recupera e serve direttamente il contenuto XML.
 */
const PropertyFeed = () => {
  useEffect(() => {
    serveXmlFeed();
  }, []);

  const serveXmlFeed = async () => {
    try {
      // Set content type for XML
      const meta = document.createElement('meta');
      meta.httpEquiv = 'Content-Type';
      meta.content = 'application/xml; charset=utf-8';
      document.head.appendChild(meta);
      
      // Set cache control headers - FONDAMENTALI per evitare cache
      const cacheControl = document.createElement('meta');
      cacheControl.httpEquiv = 'Cache-Control';
      cacheControl.content = 'no-cache, no-store, must-revalidate';
      document.head.appendChild(cacheControl);
      
      const pragma = document.createElement('meta');
      pragma.httpEquiv = 'Pragma';
      pragma.content = 'no-cache';
      document.head.appendChild(pragma);
      
      const expires = document.createElement('meta');
      expires.httpEquiv = 'Expires';
      expires.content = '0';
      document.head.appendChild(expires);
      
      // Get timestamp from URL or generate new one
      const urlParams = new URLSearchParams(window.location.search);
      const timestamp = urlParams.get('t') || Date.now();
      const forceParam = urlParams.get('force') === 'true' ? '&force=true' : '';
      
      try {
        // Recupera il feed XML dalla Netlify Function con parametri anti-cache
        const response = await fetch(`/.netlify/functions/property-feed?t=${timestamp}${forceParam}&nocache=${Date.now()}`, {
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        });
        
        if (!response.ok) {
          throw new Error(`Errore nel recupero del feed XML: ${response.status} ${response.statusText}`);
        }
        
        const xmlContent = await response.text();
        
        // Serve il contenuto XML direttamente
        document.open('text/xml; charset=UTF-8');
        document.write(xmlContent);
        document.close();
      } catch (fetchError) {
        console.error('Error fetching XML feed:', fetchError);
        
        // Generate error XML
        document.open('text/xml; charset=UTF-8');
        document.write(`<?xml version="1.0" encoding="UTF-8"?>\n<annunci>\n  <error>Errore nel caricamento del feed: ${fetchError.message}</error>\n</annunci>`);
        document.close();
      }
    } catch (error) {
      console.error('Error serving XML feed:', error);
      
      // Serve error message
      document.open('text/xml; charset=UTF-8');
      document.write(`<?xml version="1.0" encoding="UTF-8"?>\n<annunci>\n  <error>${error instanceof Error ? error.message : 'Errore sconosciuto'}</error>\n</annunci>`);
      document.close();
    }
  };

  // Return null since we're handling output via document.write
  return null;
};

export default PropertyFeed;